
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-1-graphql-is-the-better-rest.json") })
        }
      }, "path---basics-1-graphql-is-the-better-rest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---basics-1-graphql-is-the-better-rest!./.cache/json/basics-1-graphql-is-the-better-rest.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---basics-1-graphql-is-the-better-rest!./.cache/json/basics-1-graphql-is-the-better-rest.json
// module chunks = 154